import * as Auth from './Auth';
import * as Client from './Client';
import * as PersonalInfo from './PersonalInfo';
import * as RecoveryPassword from './RecoveryPassword';
import * as TotalBalance from './TotalBalance';

export default {
  Auth,
  Client,
  PersonalInfo,
  RecoveryPassword,
  TotalBalance,
};
